<template>
  <BusyOverlay :show="isBusy">
    <b-select
      :id="id"
      :options="classOptions"
      v-bind="{ ...$props, ...$attrs }"
      v-on="$listeners"
    />
  </BusyOverlay>
</template>

<script>
import meterStatesApi from '@/features/meter-states/meter-state-api'

export default {
  name: 'meter-class-selector',
  data() {
    return {
      defaultOptions: [],
      options: [],
      isBusy: false
    }
  },
  async mounted() {
    try {
      this.isBusy = true
      const payload = await meterStatesApi().list(1, 1000)
      this.options = payload.map((value) => {
        return {
          text: value.name,
          value: value.id
        }
      })
    } catch (error) {
      this.isBusy = false
      throw error
    }
    if (this.emitOnMount) {
      setTimeout(() => this.$emit('input', this.value), 400)
    }
    this.isBusy = false
  },
  computed: {
    classOptions() {
      return [...this.defaultOptions, ...this.options]
    }
  },
  props: {
    id: {
      required: false,
      default: undefined
    },
    // eslint-disable-next-line vue/no-unused-properties
    value: {
      required: false,
      default: 2
    },
    // eslint-disable-next-line vue/no-unused-properties
    size: {
      type: [String],
      default: 'md',
      required: false
    },
    emitOnMount: { default: true }
    // eslint-disable-next-line vue/no-unused-properties
    // options: {
    //   type: [Array],
    //   required: false,
    //   default: () => [
    //     { text: 'A', value: 1 },
    //     { text: 'B', value: 2 },
    //     { text: 'Nenhum', value: null }
    //   ]
    // }
  }
}
</script>

<style></style>
